webpackJsonp([0],{

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = elementIsVisible;
function elementIsVisible(element) {
  return !!(element.offsetWidth || element.offsetHeight);
}

/***/ }),

/***/ 14:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__element_is_visible__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scroll_observer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__select_all__ = __webpack_require__(3);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var supportsSrcset = 'srcset' in document.createElement('img');

var LazyLoad = function () {
  function LazyLoad() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$scrollObserver = _ref.scrollObserver,
        scrollObserver = _ref$scrollObserver === undefined ? new __WEBPACK_IMPORTED_MODULE_1__scroll_observer__["a" /* default */]() : _ref$scrollObserver,
        _ref$selector = _ref.selector,
        selector = _ref$selector === undefined ? 'img.lazyload' : _ref$selector,
        _ref$threshold = _ref.threshold,
        threshold = _ref$threshold === undefined ? 350 : _ref$threshold;

    _classCallCheck(this, LazyLoad);

    this.initialized = false;
    this.scrollObserver = scrollObserver;
    this.selector = selector;
    this.threshold = threshold;

    this.checkElements = this.checkElements.bind(this);
  }

  LazyLoad.prototype.init = function init() {
    if (this.initialized) return;
    this.initialized = true;

    this.elements = Object(__WEBPACK_IMPORTED_MODULE_2__select_all__["a" /* default */])(this.selector);
    this.checkElements();

    this.scrollObserver.add(this.checkElements);
  };

  LazyLoad.prototype.checkElements = function checkElements() {
    var _this = this;

    var elements = this.elements;
    var threshold = this.threshold;
    var clientWidth = document.documentElement.clientWidth;
    var clientHeight = document.documentElement.clientHeight;

    var processedElements = [];

    elements.forEach(function (element, idx) {
      // the element is not visible at all, no need
      if (!Object(__WEBPACK_IMPORTED_MODULE_0__element_is_visible__["a" /* default */])(element)) return;

      var rect = element.getBoundingClientRect();

      var visible = rect.top <= clientHeight + threshold && rect.right >= -threshold && rect.bottom >= -threshold && rect.left <= clientWidth + threshold;

      if (visible) {
        processedElements.push(idx);
        element.classList.add('lazyload--loaded');

        var src = element.getAttribute('data-src');
        var srcset = element.getAttribute('data-srcset');

        if (srcset && supportsSrcset) {
          element.setAttribute('srcset', srcset);
        } else {
          element.setAttribute('src', src);
        }

        element.onload = function () {
          return element.classList.add('loaded');
        };
      }

      while (processedElements.length > 0) {
        elements.splice(processedElements.pop(), 1);
      }

      if (elements.length === 0) {
        _this.scrollObserver.remove(_this.checkElements);
      }
    }, this);
  };

  return LazyLoad;
}();

/* harmony default export */ __webpack_exports__["default"] = (LazyLoad);

/***/ })

});


// WEBPACK FOOTER //
// lazyload.a92631cf46.chunk.js